import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import * as Diff2Html from 'diff2html';

@Component({
  selector: 'ze-code-diff-viewer',
  templateUrl: './code-diff-viewer.component.html',
  styleUrls: ['./code-diff-viewer.component.scss']
})
export class CodeDiffViewerComponent implements OnInit, OnChanges {

  @Input() patch: string;
  @Input() viewMode: 'side-by-side' | 'line-by-line' = 'side-by-side';

  public diffHtml: string = '';
  public showComments: boolean = true;

  ngOnInit() {
    this.generateDiffHtml();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.patch || changes.viewMode) {
      this.diffHtml = "";
      this.generateDiffHtml();
    }
  }

  private generateDiffHtml() {
    const diffOutput = Diff2Html.parse(this.patch);
    let htmlContent = Diff2Html.html(diffOutput, {
      drawFileList: false,
      matching: 'lines',
      outputFormat: this.viewMode,
    });
  
    if (this.viewMode === "line-by-line") {
      htmlContent = htmlContent.replace(
        new RegExp(
          `(<div class="d2h-file-header">[\\s\\S]*?)(<div class="d2h-file-diff">)`,
          'g'
        ),
        `$2`
      );
    } else {
      htmlContent = htmlContent.replace(
        new RegExp(
          `(<div class="d2h-file-header">[\\s\\S]*?)(<div class="d2h-files-diff">)`,
          'g'
        ),
        `$2`
      );
    }
    this.diffHtml = htmlContent;
  }
}
